import { render, staticRenderFns } from "./DialogDetalleElemento.vue?vue&type=template&id=6f46a31c&scoped=true"
import script from "./DialogDetalleElemento.vue?vue&type=script&lang=js"
export * from "./DialogDetalleElemento.vue?vue&type=script&lang=js"
import style0 from "./DialogDetalleElemento.vue?vue&type=style&index=0&id=6f46a31c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f46a31c",
  null
  
)

export default component.exports